<template>
	<div class="match_items">
		<div class="match_item" v-for="(standingGroup, key) in standings" :key="key">
			<div class="match_item-content">
				<div class="match_item-header active">
					<span>{{ key }}</span>
					<i class="ico icon-side-arrow"></i>
				</div>
				<div class="match_item-data active">
					<div class="live-table_content">
						<div class="live-table_row">
							<div class="live-table_col __1"></div>
							<div class="live-table_col __2">
								<div class="live-table_name">Команда</div>
							</div>
							<div class="live-table_col __3">
								<div class="live-table_name">И</div>
							</div>
							<div class="live-table_col __4">
								<div class="live-table_name">О</div>
							</div>
						</div>
						<div class="live-table_data">
							<div class="live-table_row" v-for="(standingItem, index) in standingGroup" :key="index">
								<div class="live-table_col __1">
									<div class="live-table_num ">{{ index + 1}}</div>
								</div>
								<div class="live-table_col __2">
									<div class="live-table_main">
										<div class="live-table_pic">
											<img :src="$hostname + standingItem.team_image_ref">
										</div>
										<router-link :to="{ name: 'team', params: {id: standingItem.team_id} }" 
													 class="live-table_name-main" href="">
											{{ standingItem.team_name }}
										</router-link>
									</div>
								</div>
								<div class="live-table_col __3">
									<div class="live-table_name-2">
										{{ standingItem.played }}
									</div>
								</div>
								<div class="live-table_col __4">
									<div class="live-table_name-2">
										{{ standingItem.points }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'underscore';
	
	export default {
		props: ['data'],
		
		computed: {
			standings() {
				return _.groupBy(this.data, 'stage_name');
			}
		}
	}
</script>

<style scoped>

</style>